import React from 'react'
import { makeStyles } from '@material-ui/core'

import {
  FormikDatePicker,
  FormikFileField,
  FormikTextField,
  SidePanel,
} from 'src/modules/ui'

const useStyles = makeStyles(theme => ({
  sidePanelContainer: {
    flexShrink: 0,
    marginLeft: 0,
    marginTop: theme.spacing(4),
    width: 'auto',
    [theme.breakpoints.up('desktop')]: {
      marginTop: theme.spacing(9),
      marginLeft: theme.spacing(4),
      width: 250,
    },
  },
  sidePanelGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}))

const InvoiceFormSidePanel = ({ children, values }) => {
  const classes = useStyles()

  return (
    <div className={classes.sidePanelContainer}>
      <SidePanel>
        <SidePanel.Item title="Details">
          <div className={classes.sidePanelGroup}>
            <FormikTextField
              fullWidth
              label="Invoice Number"
              name="invoiceNumber"
            />
            <FormikDatePicker
              label="Invoice Date"
              fullWidth
              name="invoiceDate"
              InputLabelProps={{ shrink: true }}
              placeholder="DD/MM/YYYY"
            />
            <FormikDatePicker
              label="Invoice Due Date"
              fullWidth
              name="invoiceDueDate"
              InputLabelProps={{ shrink: true }}
              placeholder="DD/MM/YYYY"
            />
          </div>
        </SidePanel.Item>
        <SidePanel.Item title="Documents">
          <div className={classes.sidePanelGroup}>
            <FormikFileField
              fullWidth
              label="Credit Note"
              margin="normal"
              name="creditNoteDocument"
            />
            <FormikTextField
              fullWidth
              label="Invoice Notes"
              name="notes"
              multiline
              minRows={5}
              type="text"
            />
          </div>
        </SidePanel.Item>
        {children}
      </SidePanel>
    </div>
  )
}

export default InvoiceFormSidePanel
